import instance from '@/utils/instance';

//书籍添加到书单
export function postMemberAddBookToList(data) {
	return instance({
		url: `/webL_api/consumer/member/book/newDetail`,
		method: 'post',
        data
	});
}

//书单明细
// export function getMemberBook(data) {
// 	return instance({
// 		url: `/webL_api/consumer/member/book/${data.id}?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
// 		method: 'get',
// 	});
// }

//书单明细
export function getMemberBook(data) {
	return instance({
		url: `/webL_api/consumer/member/book/queryDetail?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data
	});
}

//书籍收藏
export function postMemberBookCollect(data) {
	return instance({
		url: `/webL_api/consumer/member/book/collect`,
		method: 'post',
        data
	});
}

//书籍收藏列表
export function postMemberBookCollectList(data) {
	return instance({
		url: `/webL_api/consumer/member/book/collectList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
        data
	});
}


//书单移除书籍
export function deleteMemberBookCollect(data) {
	return instance({
		url: `/webL_api/consumer/member/book/removeDetail/${data }`,
		method: 'delete',
	});
}

//获取书单列表--检查有无
export function getBookListCheck(data) {
	return instance({
		url: `/webL_api/consumer/member/getBookListCheck`,
		method: 'post',
		data
	});
}

//书单验证
export function postMemberBookListAddToMyLawLibraryVerify(data) {
	return instance({
		url: `/webL_api/corporate/acc/verifyBookInfo?verifyCode=${data}`,
		method: 'post',
	});
}





